import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AssetData,
  AssetsRequest,
  CreateRequest,
  UpdateRequest,
  PaginatedData,
  PostCommentRequest,
  ResponseData,
  ReviewData,
  ReviewsRequest,
  Label,
  PutReviewLabelsRequest,
  ReviewLabels, Network
} from '@models/online-reputation.models';
import { withFormattedPeriodRanges } from '@core/utils/period-range.util';

@Injectable({
  providedIn: 'root'
})
export class ReviewsService {
  private readonly httpClient = inject(HttpClient);

  listReviews(body: ReviewsRequest): Observable<PaginatedData<ReviewData>> {
    return this.httpClient.post<PaginatedData<ReviewData>>('api/reviews', withFormattedPeriodRanges(body));
  }

  listAssets(body: AssetsRequest): Observable<PaginatedData<AssetData>> {
    return this.httpClient.post<PaginatedData<AssetData>>('api/assets', body);
  }

  listLabels(): Observable<Label[]> {
    return this.httpClient.get<Label[]>('api/reviews/labels');
  }
  createAsset(body: CreateRequest): Observable<AssetData> {
    return this.httpClient.put<AssetData>('api/assets', body);
  }

  updateAsset(id: string, body: UpdateRequest): Observable<AssetData> {
    return this.httpClient.patch<AssetData>(`api/assets/${id}`, body);
  }

  deleteAsset(id: string): Observable<ResponseData<string>> {
    return this.httpClient.delete<ResponseData<string>>(`api/assets/${id}`);
  }

  postComment(body: PostCommentRequest): Observable<ResponseData<string>> {
    return this.httpClient.post<ResponseData<string>>('api/reviews/comment', body);
  }

  generateComment(reviewId: string): Observable<ResponseData<string>> {
    return this.httpClient.post<ResponseData<string>>(`api/reviews/${reviewId}/generateComment`, {});
  }

  tagReviewWithLabel(body: PutReviewLabelsRequest): Observable<number[]> {
    return this.httpClient.put<number[]>(`api/reviews/labels`, body);
  }

  syncReviews(body: ReviewsRequest): Observable<string> {
    return this.httpClient.post<string>('api/elastic/sync/reviews', body);
  }
}
